/**
 * GENERATED BY KRPC GEN - LESS MODIFY BY HAND
 * pushactivity-service.ts  2026-05-15T13:37:49+08:00
 */
import type { R, RpcService, MethodConfig as M } from 'krpc-base'

import type { PushActivityCallbackReq, PushActivityCallbackRes } from './wy-dto'

const _ = 'PushActivity/'

export class PushActivityService {
  constructor(readonly r: RpcService) {}

  pushCallback(d: PushActivityCallbackReq, m?: M): R<PushActivityCallbackRes> {
    return this.r.async(_ + 'pushCallback', d, m)
  }
}
